import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger, setActiveStepOnBody } from '../utils';

export const customerStepLoadingConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.CUSTOMER_STEP_LOADING,
  handler: ({ detail }) => {
    logger('Customer Step Loading');
    setActiveStepOnBody(detail.activeStepType);
    console.log(detail);
  },
};
